import React from 'react';
import { TopBar } from '../components/TopBar';
import { CountdownBar } from '../components/CountdownBar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSolutionSection } from '../components/ProblemSolutionSection';
import { CollectionSection } from '../components/CollectionSection';
import { PreviewCarousel } from '../components/PreviewCarousel';
import { AudienceSection } from '../components/AudienceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { SalesSection } from '../components/SalesSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" style={{
    fontFamily: "'Nunito', sans-serif"
  }} data-id="element-267">
      <MetaPixel data-id="element-268" />
      <TopBar data-id="element-269" />
      <CountdownBar variant="banner" data-id="element-270" />
      <HeroSection data-id="element-271" />
      <ProblemSolutionSection data-id="element-272" />
      <CollectionSection data-id="element-273" />
      <PreviewCarousel data-id="element-274" />
      <AudienceSection data-id="element-275" />
      <TestimonialsSection data-id="element-276" />
      <SalesSection data-id="element-277" />
      <FAQSection data-id="element-278" />
      <SocialProofPopup data-id="element-279" />
    </main>;
}